import { FC, useState, createContext, useContext } from 'react';
import { EepBMModel } from 'src/models/businessManager/businessManager.model';
import { EaSkillData } from 'src/models/skill/skill.model';

type BusinessManagerContext = {
    eepBMData: EepBMModel;
    setEepBMDataContext: (dataValue) => void;
    BDSkillsData: EaSkillData[];
    setBDSkillsDataContext: (dataValue) => void;
    SCSkillsData: EaSkillData[];
    setSCSkillsDataContext: (dataValue) => void;
    RCSkillsData: EaSkillData[];
    setRCSkillsDataContext: (dataValue) => void;
    MHSkillsData: EaSkillData[];
    setMHSkillsDataContext: (dataValue) => void;
    GCSkillsData: EaSkillData[];
    setGCSkillsDataContext: (dataValue) => void;
    POSkillsData: EaSkillData[];
    setPOSkillsDataContext: (dataValue) => void;
    BMSkillsData: EaSkillData[];
    setBMSkillsDataContext: (dataValue) => void;
    CMSkillsData: EaSkillData[];
    setCMSkillsDataContext: (dataValue) => void;
    EPSkillsData: EaSkillData[];
    setEPSkillsDataContext: (dataValue) => void;
    showBDSkills: boolean;
    setShowBDSkillsContext: (dataValue) => void;
    showSCSkills: boolean;
    setShowSCSkillsContext: (dataValue) => void;
    showRCSkills: boolean;
    setShowRCSkillsContext: (dataValue) => void;
    showMHSkills: boolean;
    setShowMHSkillsContext: (dataValue) => void;
    showGCSkills: boolean;
    setShowGCSkillsContext: (dataValue) => void;
    showPOSkills: boolean;
    setShowPOSkillsContext: (dataValue) => void;
    showBMSkills: boolean;
    setShowBMSkillsContext: (dataValue) => void;
    showCMSkills: boolean;
    setShowCMSkillsContext: (dataValue) => void;
    showEPSkills: boolean;
    setShowEPSkillsContext: (dataValue) => void;
    BDSkillsDataKO: boolean;
    SCSkillsDataKO: boolean;
    RCSkillsDataKO: boolean;
    MHSkillsDataKO: boolean;
    GCSkillsDataKO: boolean;
    POSkillsDataKO: boolean;
    BMSkillsDataKO: boolean;
    CMSkillsDataKO: boolean;
    EPSkillsDataKO: boolean;
    setBDSkillsDataKOContext: (dataValue) => void;
    setSCSkillsDataKOContext: (dataValue) => void;
    setRCSkillsDataKOContext: (dataValue) => void;
    setMHSkillsDataKOContext: (dataValue) => void;
    setGCSkillsDataKOContext: (dataValue) => void;
    setPOSkillsDataKOContext: (dataValue) => void;
    setBMSkillsDataKOContext: (dataValue) => void;
    setCMSkillsDataKOContext: (dataValue) => void;
    setEPSkillsDataKOContext: (dataValue) => void;
    chartData: any;
    setChartDataContext: (dataValue) => void;
    idBusinessManagerContext: number;
    setIdBusinessManagerContext: (dataValue) => void;
};

export const BusinessManagerContext = createContext<BusinessManagerContext>(
    {} as BusinessManagerContext
);

export const BusinessManagerProvider: FC = ({ children }) => {
    const [BDSkillsDataKO, setBDSkillsDataKO] = useState<boolean>(false);
    const [SCSkillsDataKO, setSCSkillsDataKO] = useState<boolean>(false);
    const [RCSkillsDataKO, setRCSkillsDataKO] = useState<boolean>(false);
    const [MHSkillsDataKO, setMHSkillsDataKO] = useState<boolean>(false);
    const [GCSkillsDataKO, setGCSkillsDataKO] = useState<boolean>(false);
    const [POSkillsDataKO, setPOSkillsDataKO] = useState<boolean>(false);
    const [BMSkillsDataKO, setBMSkillsDataKO] = useState<boolean>(false);
    const [CMSkillsDataKO, setCMSkillsDataKO] = useState<boolean>(false);
    const [EPSkillsDataKO, setEPSkillsDataKO] = useState<boolean>(false);

    const setBDSkillsDataKOContext = (dataValue) => {
        setBDSkillsDataKO(dataValue)
    }
    const setSCSkillsDataKOContext = (dataValue) => {
        setSCSkillsDataKO(dataValue)
    }
    const setRCSkillsDataKOContext = (dataValue) => {
        setRCSkillsDataKO(dataValue)
    }
    const setMHSkillsDataKOContext = (dataValue) => {
        setMHSkillsDataKO(dataValue)
    }
    const setGCSkillsDataKOContext = (dataValue) => {
        setGCSkillsDataKO(dataValue)
    }
    const setPOSkillsDataKOContext = (dataValue) => {
        setPOSkillsDataKO(dataValue)
    }
    const setBMSkillsDataKOContext = (dataValue) => {
        setBMSkillsDataKO(dataValue)
    }
    const setCMSkillsDataKOContext = (dataValue) => {
        setCMSkillsDataKO(dataValue)
    }
    const setEPSkillsDataKOContext = (dataValue) => {
        setEPSkillsDataKO(dataValue)
    }

    const [eepBMData, setEepBMData] = useState<EepBMModel>({});
    const setEepBMDataContext = (dataValue) => {
        setEepBMData(dataValue);
    };

    const [BDSkillsData, setBDSkillsData] = useState<EaSkillData[]>([]);
    const setBDSkillsDataContext = (dataValue) => {
        setBDSkillsData(dataValue);
    };

    const [SCSkillsData, setSCSkillsData] = useState<EaSkillData[]>([]);
    const setSCSkillsDataContext = (dataValue) => {
        setSCSkillsData(dataValue);
    };

    const [RCSkillsData, setRCSkillsData] = useState<EaSkillData[]>([]);
    const setRCSkillsDataContext = (dataValue) => {
        setRCSkillsData(dataValue);
    };

    const [MHSkillsData, setMHSkillsData] = useState<EaSkillData[]>([]);
    const setMHSkillsDataContext = (dataValue) => {
        setMHSkillsData(dataValue);
    };

    const [GCSkillsData, setGCSkillsData] = useState<EaSkillData[]>([]);
    const setGCSkillsDataContext = (dataValue) => {
        setGCSkillsData(dataValue);
    };

    const [POSkillsData, setPOSkillsData] = useState<EaSkillData[]>([]);
    const setPOSkillsDataContext = (dataValue) => {
        setPOSkillsData(dataValue);
    };

    const [BMSkillsData, setBMSkillsData] = useState<EaSkillData[]>([]);
    const setBMSkillsDataContext = (dataValue) => {
        setBMSkillsData(dataValue);
    };

    const [CMSkillsData, setCMSkillsData] = useState<EaSkillData[]>([]);
    const setCMSkillsDataContext = (dataValue) => {
        setCMSkillsData(dataValue);
    };

    const [EPSkillsData, setEPSkillsData] = useState<EaSkillData[]>([]);
    const setEPSkillsDataContext = (dataValue) => {
        setEPSkillsData(dataValue);
    };
    // show each data
    const [showBDSkills, setShowBDSkills] = useState<boolean>(false);
    const setShowBDSkillsContext = (dataValue) => {
        setShowBDSkills(dataValue);
    };
    const [showSCSkills, setShowSCSkills] = useState<boolean>(false);
    const setShowSCSkillsContext = (dataValue) => {
        setShowSCSkills(dataValue);
    };

    const [showRCSkills, setShowRCSkills] = useState<boolean>(false);
    const setShowRCSkillsContext = (dataValue) => {
        setShowRCSkills(dataValue);
    };

    const [showMHSkills, setShowMHSkills] = useState<boolean>(false);
    const setShowMHSkillsContext = (dataValue) => {
        setShowMHSkills(dataValue);
    };

    const [showGCSkills, setShowGCSkills] = useState<boolean>(false);
    const setShowGCSkillsContext = (dataValue) => {
        setShowGCSkills(dataValue);
    };

    const [showPOSkills, setShowPOSkills] = useState<boolean>(false);
    const setShowPOSkillsContext = (dataValue) => {
        setShowPOSkills(dataValue);
    };

    const [showBMSkills, setShowBMSkills] = useState<boolean>(false);
    const setShowBMSkillsContext = (dataValue) => {
        setShowBMSkills(dataValue);
    };

    const [showCMSkills, setShowCMSkills] = useState<boolean>(false);
    const setShowCMSkillsContext = (dataValue) => {
        setShowCMSkills(dataValue);
    };

    const [showEPSkills, setShowEPSkills] = useState<boolean>(false);
    const setShowEPSkillsContext = (dataValue) => {
        setShowEPSkills(dataValue);
    };

    const [chartData, setChartData] = useState<FormData>();
    const setChartDataContext = (dataValue) => {
        setChartData(dataValue);
    };

    const [idBusinessManagerContext, setIdBusinessManagerContext] = useState<number>(0);

    return (
        <BusinessManagerContext.Provider value={{
            eepBMData,
            setEepBMDataContext,
            BDSkillsData,
            setBDSkillsDataContext,
            SCSkillsData,
            setSCSkillsDataContext,
            RCSkillsData,
            setRCSkillsDataContext,
            MHSkillsData,
            setMHSkillsDataContext,
            GCSkillsData,
            setGCSkillsDataContext,
            POSkillsData,
            setPOSkillsDataContext,
            BMSkillsData,
            setBMSkillsDataContext,
            CMSkillsData,
            setCMSkillsDataContext,
            EPSkillsData,
            setEPSkillsDataContext,
            showBDSkills,
            setShowBDSkillsContext,
            showSCSkills,
            setShowSCSkillsContext,
            showRCSkills,
            setShowRCSkillsContext,
            showMHSkills,
            setShowMHSkillsContext,
            showGCSkills,
            setShowGCSkillsContext,
            showPOSkills,
            setShowPOSkillsContext,
            showBMSkills,
            setShowBMSkillsContext,
            showCMSkills,
            setShowCMSkillsContext,
            showEPSkills,
            setShowEPSkillsContext,
            BDSkillsDataKO,
            SCSkillsDataKO,
            RCSkillsDataKO,
            MHSkillsDataKO,
            GCSkillsDataKO,
            POSkillsDataKO,
            BMSkillsDataKO,
            CMSkillsDataKO,
            EPSkillsDataKO,
            setBDSkillsDataKOContext,
            setSCSkillsDataKOContext,
            setRCSkillsDataKOContext,
            setMHSkillsDataKOContext,
            setGCSkillsDataKOContext,
            setPOSkillsDataKOContext,
            setBMSkillsDataKOContext,
            setCMSkillsDataKOContext,
            setEPSkillsDataKOContext,
            chartData,
            setChartDataContext,
            idBusinessManagerContext,
            setIdBusinessManagerContext
        }}
        >
            {children}
        </BusinessManagerContext.Provider>
    );
};
